export default __webpack_public_path__ + "static/media/particle.bc42fd46.jfif";